import { apiClient } from './client'

export type BadgeTextArea = {
  id: string
  label: string
  text: string
  x: number
  y: number
  width: number
  height: number
  fontFamily: string
  fontSize: number
  fontWeight: string
  color: string
  textAlign: 'left' | 'center' | 'right'
  verticalAlign: 'top' | 'middle' | 'bottom'
  maxLines: number
  curve: number
}

export type Badge = {
  id: string
  slug: string
  name: string
  category: string
  description?: string | null
  baseImageUrl?: string | null
  renderedImageUrl?: string | null
  layoutAreas: BadgeTextArea[]
  isArchived: boolean
  createdAt: string
  updatedAt: string
}

export type BadgePayload = {
  slug?: string | null
  name: string
  category: string
  description?: string | null
  baseImageUrl?: string | null
  renderedImageUrl?: string | null
  layoutAreas: BadgeTextArea[]
  isArchived?: boolean
}

export type BadgeImageUploadResponse = {
  imageUrl: string
  objectKey: string
}

export async function getBadges(includeArchived = false, category?: string): Promise<Badge[]> {
  const { data } = await apiClient.get<Badge[]>('/api/admin/badges', {
    params: { includeArchived, category }
  })
  return data
}

export async function createBadge(payload: BadgePayload): Promise<Badge> {
  const { data } = await apiClient.post<Badge>('/api/admin/badges', payload)
  return data
}

export async function updateBadge(id: string, payload: BadgePayload): Promise<Badge> {
  const { data } = await apiClient.put<Badge>(`/api/admin/badges/${id}`, payload)
  return data
}

export async function deleteBadge(id: string): Promise<void> {
  await apiClient.delete(`/api/admin/badges/${id}`)
}

export async function archiveBadge(id: string, archived = true): Promise<Badge> {
  const { data } = await apiClient.post<Badge>(`/api/admin/badges/${id}/archive`, null, {
    params: { archived }
  })
  return data
}

export async function uploadBadgeImage(
  file: File,
  badgeKey?: string,
  imageKind: 'base' | 'rendered' = 'rendered'
): Promise<BadgeImageUploadResponse> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('imageKind', imageKind)

  if (badgeKey?.trim()) {
    formData.append('badgeKey', badgeKey.trim())
  }

  const { data } = await apiClient.post<BadgeImageUploadResponse>('/api/admin/badges/image/upload', formData)
  return data
}
